import type { RouteRecordRaw } from 'vue-router'
import { ROUTE_ROLES } from '@/utils/permissions'

const routes: RouteRecordRaw[] = [
  {
    path: '/fund/deposit',
    name: 'FundDeposit',
    component: () => import('@/views/fund/deposit.vue'),
    meta: {
      title: '入金审核',
      permission: 'fund:deposit',
      roles: ROUTE_ROLES.fundOperation
    }
  },
  {
    path: '/fund/withdraw',
    name: 'FundWithdraw',
    component: () => import('@/views/fund/withdraw.vue'),
    meta: {
      title: '出金审核',
      permission: 'fund:withdraw',
      roles: ROUTE_ROLES.fundOperation
    }
  },
  {
    path: '/fund/reconciliation',
    name: 'FundReconciliation',
    component: () => import('@/views/fund/reconciliation.vue'),
    meta: {
      title: '对账异常',
      permission: 'fund:reconciliation',
      roles: ROUTE_ROLES.fundOperation
    }
  },
  {
    path: '/fund/runtime-balance',
    name: 'FundRuntimeBalance',
    component: () => import('@/views/fund/runtimeBalance.vue'),
    meta: {
      title: '余额对账',
      permission: 'fund:runtime-balance',
      roles: ROUTE_ROLES.fundOperation
    }
  }
]

export default routes
